import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProcurementIncomingAskForQuoteDetailRelatedQuotationTableItem from './ProcurementIncomingAskForQuoteDetailRelatedQuotationTableItem';
import GraphQLTable from '../../../../../../../components/_table/GraphQLTable';
import { IOrderSchema } from '../../../../../../../../graphql/type/order';
import {
  IOrderQueryData,
  IOrderVars,
  useOrderQuery,
} from '../../../../../../../../graphql/query/order/useOrderQuery';
import Context from '../../../../../../../context';
import ORDER from '../../../../../../../components/constant/order';

interface IProps {
  referenceId: string;
}

export default function ProcurementIncomingAskForQuoteDetailRelatedQuotationTable(
  props: IProps
) {
  const { referenceId } = props;
  const { t } = useTranslation();
  const [tableRefreshKey, setTableRefreshKey] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<IOrderSchema[]>([]);
  const { company } = useContext(Context);

  return (
    <>
      <GraphQLTable<IOrderQueryData, IOrderSchema, IOrderVars>
        refreshKey={tableRefreshKey}
        select={`	 
              _id 
              buyer {
                contact {
                  type 
                  company {
                    companyData {
                      _id
                      name {
                          la
                          text
                      }
                      origin
                      slug
                    }
                    id 
                  }
                  user {
                    userData {
                       _id 
                       profile {
                        name {
                          firstname
                          lastname
                        }
                       }
                    }
                    id 
                  }
                }
              }
              seller {
                company {
                  id 
                  companyData {
                    _id
                    name {
                        la
                        text
                    }
                    origin
                    slug
                  }
                }
              }
              details {
                status
              }
              payment {
                currency 
                total_paid
              }
              created {
                time
              }
       	 `}
        useQuery={useOrderQuery}
        renderHeader={[
          {
            field: '_id',
            label: t('id'),
            align: 'left',
            sortable: true,
          },
          {
            field: 'total',
            label: t('total'),
            align: 'center',
          },
          {
            field: 'to',
            label: t('to'),
            align: 'center',
          },
          {
            field: 'createdTime',
            label: t('created'),
            align: 'center',
            sortable: true,
          },
          {
            field: 'status',
            label: t('status'),
            align: 'center',
          },
        ]}
        renderItem={(item) => (
          <ProcurementIncomingAskForQuoteDetailRelatedQuotationTableItem
            item={item}
            setTableRefreshKey={setTableRefreshKey}
          />
        )}
        onItemSelected={setSelectedItems}
        selectedItems={selectedItems}
        searchFields={{
          _id: { label: t('id') },
        }}
        title={t('quotation_from_supplier')}
        defaultSort="createdTime"
        defaultSortOrder={-1}
        defaultFilterOptions={{
          referenceType: ORDER.REFERENCE_TYPE.ASK_FOR_QUOTE,
          referenceId,
          sellerCompanyId: company._id,
        }}
        itemKey="_id"
      />
    </>
  );
}
